// Generated by `yarn tokens:import` from the Figma "semantic" variables export. Do not edit.

export type FigmaColor = {
    alias: string
    mode: string
    tenantDependent?: true
    value: string
    boundTo?: string
    boundToCollection?: string
}

export const semanticColors = {
    'base-ui': {
        'action': {
            'default': {
                alias: 'action/default',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#3459C6',
                boundTo: 'primary/default',
            },
            'grey-action': {
                alias: 'action/grey-action',
                mode: 'base-ui',
                value: '#8F8F92',
                boundTo: 'graphics/grey',
            },
            'grey-action-hover': {
                alias: 'action/grey-action-hover',
                mode: 'base-ui',
                value: '#9B9B9E',
                boundTo: 'graphics/grey-hover',
            },
            'hover': {
                alias: 'action/hover',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#3D66DA',
                boundTo: 'primary/hover',
            },
            'overlay-action': {
                alias: 'action/overlay-action',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#ECEEF5',
                boundTo: 'silver/100',
                boundToCollection: '_Primitives graphics',
            },
            'overlay-action-hover': {
                alias: 'action/overlay-action-hover',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#E2E4EB',
                boundTo: 'silver/200',
                boundToCollection: '_Primitives graphics',
            },
            'overlay-action-pressed': {
                alias: 'action/overlay-action-pressed',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#D5D7DE',
                boundTo: 'silver/300',
                boundToCollection: '_Primitives graphics',
            },
        },
        'background': {
            'canvas': { alias: 'background/canvas', mode: 'base-ui', value: '#111114' },
            'canvas-hover': { alias: 'background/canvas-hover', mode: 'base-ui', value: '#1B1B1E' },
            'canvas-pressed': {
                alias: 'background/canvas-pressed',
                mode: 'base-ui',
                value: '#0A0A0D',
            },
            'elevation': { alias: 'background/elevation', mode: 'base-ui', value: '#262629' },
            'elevation-hover': {
                alias: 'background/elevation-hover',
                mode: 'base-ui',
                value: '#303033',
            },
            'elevation-pressed': {
                alias: 'background/elevation-pressed',
                mode: 'base-ui',
                value: '#1F1F22',
            },
            'highlight': { alias: 'background/highlight', mode: 'base-ui', value: '#2D2D30' },
            'highlight-hover': {
                alias: 'background/highlight-hover',
                mode: 'base-ui',
                value: '#37373A',
            },
            'highlight-pressed': {
                alias: 'background/highlight-pressed',
                mode: 'base-ui',
                value: '#232326',
            },
            'input': {
                alias: 'background/input',
                mode: 'base-ui',
                value: '#111114',
                boundTo: 'background/canvas',
            },
            'input-hover': {
                alias: 'background/input-hover',
                mode: 'base-ui',
                value: '#1B1B1E',
                boundTo: 'background/canvas-hover',
            },
            'sub-surface': { alias: 'background/sub-surface', mode: 'base-ui', value: '#18181B' },
            'sub-surface-hover': {
                alias: 'background/sub-surface-hover',
                mode: 'base-ui',
                value: '#222129',
            },
            'sub-surface-pressed': {
                alias: 'background/sub-surface-pressed',
                mode: 'base-ui',
                value: '#111114',
            },
            'surface': { alias: 'background/surface', mode: 'base-ui', value: '#1F1F22' },
            'surface-hover': {
                alias: 'background/surface-hover',
                mode: 'base-ui',
                value: '#29292C',
            },
            'surface-pressed': {
                alias: 'background/surface-pressed',
                mode: 'base-ui',
                value: '#18181B',
            },
        },
        'border': {
            overlay: {
                alias: 'border/overlay',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            strong: { alias: 'border/strong', mode: 'base-ui', value: '#505051' },
            subtle: { alias: 'border/subtle', mode: 'base-ui', value: '#2A2D32' },
            transparent: { alias: 'border/transparent', mode: 'base-ui', value: '#00000000' },
        },
        'charts': {
            'apron-temperature': {
                alias: 'charts/apron-temperature',
                mode: 'base-ui',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'dew-point': {
                alias: 'charts/dew-point',
                mode: 'base-ui',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-1': {
                alias: 'charts/level-1',
                mode: 'base-ui',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-2': {
                alias: 'charts/level-2',
                mode: 'base-ui',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-3': {
                alias: 'charts/level-3',
                mode: 'base-ui',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-4': {
                alias: 'charts/level-4',
                mode: 'base-ui',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain': {
                alias: 'charts/rain',
                mode: 'base-ui',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain-snow': {
                alias: 'charts/rain-snow',
                mode: 'base-ui',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'snow': {
                alias: 'charts/snow',
                mode: 'base-ui',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'temperature': {
                alias: 'charts/temperature',
                mode: 'base-ui',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'wind': {
                alias: 'charts/wind',
                mode: 'base-ui',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'content': {
            'default': { alias: 'content/default', mode: 'base-ui', value: '#E5E5E6' },
            'destructive': { alias: 'content/destructive', mode: 'base-ui', value: '#FF4529' },
            'inverted': { alias: 'content/inverted', mode: 'base-ui', value: '#2B2B2B' },
            'knockout': { alias: 'content/knockout', mode: 'base-ui', value: '#FFFFFF' },
            'link': {
                alias: 'content/link',
                mode: 'base-ui',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'link-hover': {
                alias: 'content/link-hover',
                mode: 'base-ui',
                value: '#A0D2FF',
                boundTo: 'blue/300',
                boundToCollection: '_Primitives graphics',
            },
            'link-pressed': {
                alias: 'content/link-pressed',
                mode: 'base-ui',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'link-visited': {
                alias: 'content/link-visited',
                mode: 'base-ui',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'logotype': { alias: 'content/logotype', mode: 'base-ui', value: '#FFFFFF' },
            'muted': { alias: 'content/muted', mode: 'base-ui', value: '#ACADAF' },
            'on-action': {
                alias: 'content/on-action',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#ECF1F8',
                boundTo: 'content/on-primary',
            },
            'on-primary': {
                alias: 'content/on-primary',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#ECF1F8',
            },
        },
        'destructive': {
            border: {
                alias: 'destructive/border',
                mode: 'base-ui',
                value: '#FF4529',
                boundTo: 'content/destructive',
            },
            default: {
                alias: 'destructive/default',
                mode: 'base-ui',
                value: '#E72400',
                boundTo: 'status/critical',
            },
            hover: {
                alias: 'destructive/hover',
                mode: 'base-ui',
                value: '#DC2100',
                boundTo: 'status/critical-hover',
            },
            pressed: {
                alias: 'destructive/pressed',
                mode: 'base-ui',
                value: '#D01F00',
                boundTo: 'status/critical-pressed',
            },
        },
        'flights': {
            'arrivals': {
                alias: 'flights/arrivals',
                mode: 'base-ui',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-local': {
                alias: 'flights/arrivals-local',
                mode: 'base-ui',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-transfer': {
                alias: 'flights/arrivals-transfer',
                mode: 'base-ui',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'cancelled': {
                alias: 'flights/cancelled',
                mode: 'base-ui',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'delayed': {
                alias: 'flights/delayed',
                mode: 'base-ui',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures': {
                alias: 'flights/departures',
                mode: 'base-ui',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'departures-local': {
                alias: 'flights/departures-local',
                mode: 'base-ui',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures-transfer': {
                alias: 'flights/departures-transfer',
                mode: 'base-ui',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'on-time': {
                alias: 'flights/on-time',
                mode: 'base-ui',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'focus': {
            ring: {
                alias: 'focus/ring',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#3459C6',
                boundTo: 'action/default',
            },
        },
        'graphics': {
            'blue': {
                alias: 'graphics/blue',
                mode: 'base-ui',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'blue-hover': {
                alias: 'graphics/blue-hover',
                mode: 'base-ui',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'blue-light': {
                alias: 'graphics/blue-light',
                mode: 'base-ui',
                value: '#0B233B',
                boundTo: 'blue/900',
                boundToCollection: '_Primitives graphics',
            },
            'blue-medium': {
                alias: 'graphics/blue-medium',
                mode: 'base-ui',
                value: '#437DBC',
                boundTo: 'blue/700',
                boundToCollection: '_Primitives graphics',
            },
            'blue-pressed': {
                alias: 'graphics/blue-pressed',
                mode: 'base-ui',
                value: '#63A5EE',
                boundTo: 'blue/600',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey': {
                alias: 'graphics/dark-grey',
                mode: 'base-ui',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-hover': {
                alias: 'graphics/dark-grey-hover',
                mode: 'base-ui',
                value: '#6B6B6F',
                boundTo: 'dark-grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-pressed': {
                alias: 'graphics/dark-grey-pressed',
                mode: 'base-ui',
                value: '#555558',
                boundTo: 'dark-grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'green': {
                alias: 'graphics/green',
                mode: 'base-ui',
                value: '#79C379',
                boundTo: 'green/500',
                boundToCollection: '_Primitives graphics',
            },
            'green-hover': {
                alias: 'graphics/green-hover',
                mode: 'base-ui',
                value: '#84CC84',
                boundTo: 'green/400',
                boundToCollection: '_Primitives graphics',
            },
            'green-pressed': {
                alias: 'graphics/green-pressed',
                mode: 'base-ui',
                value: '#6DB66D',
                boundTo: 'green/600',
                boundToCollection: '_Primitives graphics',
            },
            'grey': {
                alias: 'graphics/grey',
                mode: 'base-ui',
                value: '#8F8F92',
                boundTo: 'grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'grey-hover': {
                alias: 'graphics/grey-hover',
                mode: 'base-ui',
                value: '#9B9B9E',
                boundTo: 'grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'grey-pressed': {
                alias: 'graphics/grey-pressed',
                mode: 'base-ui',
                value: '#838386',
                boundTo: 'grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'indigo': {
                alias: 'graphics/indigo',
                mode: 'base-ui',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-hover': {
                alias: 'graphics/indigo-hover',
                mode: 'base-ui',
                value: '#97B4FF',
                boundTo: 'indigo/400',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-light': {
                alias: 'graphics/indigo-light',
                mode: 'base-ui',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-medium': {
                alias: 'graphics/indigo-medium',
                mode: 'base-ui',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-pressed': {
                alias: 'graphics/indigo-pressed',
                mode: 'base-ui',
                value: '#819DF1',
                boundTo: 'indigo/600',
                boundToCollection: '_Primitives graphics',
            },
            'lavender': {
                alias: 'graphics/lavender',
                mode: 'base-ui',
                value: '#BF99EF',
                boundTo: 'lavender/500',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-hover': {
                alias: 'graphics/lavender-hover',
                mode: 'base-ui',
                value: '#C8A3F8',
                boundTo: 'lavender/400',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-pressed': {
                alias: 'graphics/lavender-pressed',
                mode: 'base-ui',
                value: '#B38DE2',
                boundTo: 'lavender/600',
                boundToCollection: '_Primitives graphics',
            },
            'lime': {
                alias: 'graphics/lime',
                mode: 'base-ui',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'lime-hover': {
                alias: 'graphics/lime-hover',
                mode: 'base-ui',
                value: '#9FC76E',
                boundTo: 'lime/400',
                boundToCollection: '_Primitives graphics',
            },
            'lime-pressed': {
                alias: 'graphics/lime-pressed',
                mode: 'base-ui',
                value: '#89B156',
                boundTo: 'lime/600',
                boundToCollection: '_Primitives graphics',
            },
            'orange': {
                alias: 'graphics/orange',
                mode: 'base-ui',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'orange-hover': {
                alias: 'graphics/orange-hover',
                mode: 'base-ui',
                value: '#F3A264',
                boundTo: 'orange/400',
                boundToCollection: '_Primitives graphics',
            },
            'orange-light': {
                alias: 'graphics/orange-light',
                mode: 'base-ui',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'orange-medium': {
                alias: 'graphics/orange-medium',
                mode: 'base-ui',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'orange-pressed': {
                alias: 'graphics/orange-pressed',
                mode: 'base-ui',
                value: '#DC8C4B',
                boundTo: 'orange/600',
                boundToCollection: '_Primitives graphics',
            },
            'pink': {
                alias: 'graphics/pink',
                mode: 'base-ui',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'pink-hover': {
                alias: 'graphics/pink-hover',
                mode: 'base-ui',
                value: '#EF96CB',
                boundTo: 'pink/400',
                boundToCollection: '_Primitives graphics',
            },
            'pink-light': {
                alias: 'graphics/pink-light',
                mode: 'base-ui',
                value: '#331628',
                boundTo: 'pink/900',
                boundToCollection: '_Primitives graphics',
            },
            'pink-medium': {
                alias: 'graphics/pink-medium',
                mode: 'base-ui',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'pink-pressed': {
                alias: 'graphics/pink-pressed',
                mode: 'base-ui',
                value: '#D880B5',
                boundTo: 'pink/600',
                boundToCollection: '_Primitives graphics',
            },
            'red': {
                alias: 'graphics/red',
                mode: 'base-ui',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'red-hover': {
                alias: 'graphics/red-hover',
                mode: 'base-ui',
                value: '#FD978A',
                boundTo: 'red/400',
                boundToCollection: '_Primitives graphics',
            },
            'red-pressed': {
                alias: 'graphics/red-pressed',
                mode: 'base-ui',
                value: '#E68174',
                boundTo: 'red/600',
                boundToCollection: '_Primitives graphics',
            },
            'silver': {
                alias: 'graphics/silver',
                mode: 'base-ui',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'silver-hover': {
                alias: 'graphics/silver-hover',
                mode: 'base-ui',
                value: '#C8CAD1',
                boundTo: 'silver/400',
                boundToCollection: '_Primitives graphics',
            },
            'silver-light': {
                alias: 'graphics/silver-light',
                mode: 'base-ui',
                value: '#2C2E33',
                boundTo: 'silver/900',
                boundToCollection: '_Primitives graphics',
            },
            'silver-medium': {
                alias: 'graphics/silver-medium',
                mode: 'base-ui',
                value: '#8D8F95',
                boundTo: 'silver/700',
                boundToCollection: '_Primitives graphics',
            },
            'silver-pressed': {
                alias: 'graphics/silver-pressed',
                mode: 'base-ui',
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            'teal': {
                alias: 'graphics/teal',
                mode: 'base-ui',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'teal-hover': {
                alias: 'graphics/teal-hover',
                mode: 'base-ui',
                value: '#30CFD1',
                boundTo: 'teal/400',
                boundToCollection: '_Primitives graphics',
            },
            'teal-light': {
                alias: 'graphics/teal-light',
                mode: 'base-ui',
                value: '#00292A',
                boundTo: 'teal/900',
                boundToCollection: '_Primitives graphics',
            },
            'teal-medium': {
                alias: 'graphics/teal-medium',
                mode: 'base-ui',
                value: '#008E91',
                boundTo: 'teal/700',
                boundToCollection: '_Primitives graphics',
            },
            'teal-pressed': {
                alias: 'graphics/teal-pressed',
                mode: 'base-ui',
                value: '#00B9BB',
                boundTo: 'teal/600',
                boundToCollection: '_Primitives graphics',
            },
            'violet': {
                alias: 'graphics/violet',
                mode: 'base-ui',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'violet-hover': {
                alias: 'graphics/violet-hover',
                mode: 'base-ui',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'violet-light': {
                alias: 'graphics/violet-light',
                mode: 'base-ui',
                value: '#241B39',
                boundTo: 'violet/900',
                boundToCollection: '_Primitives graphics',
            },
            'violet-medium': {
                alias: 'graphics/violet-medium',
                mode: 'base-ui',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'violet-pressed': {
                alias: 'graphics/violet-pressed',
                mode: 'base-ui',
                value: '#A990E7',
                boundTo: 'violet/600',
                boundToCollection: '_Primitives graphics',
            },
            'yellow': {
                alias: 'graphics/yellow',
                mode: 'base-ui',
                value: '#D3A742',
                boundTo: 'yellow/500',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-hover': {
                alias: 'graphics/yellow-hover',
                mode: 'base-ui',
                value: '#DCB151',
                boundTo: 'yellow/400',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-pressed': {
                alias: 'graphics/yellow-pressed',
                mode: 'base-ui',
                value: '#C69A33',
                boundTo: 'yellow/600',
                boundToCollection: '_Primitives graphics',
            },
        },
        'primary': {
            border: {
                alias: 'primary/border',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#405088',
            },
            default: {
                alias: 'primary/default',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#3459C6',
            },
            hover: {
                alias: 'primary/hover',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#3D66DA',
            },
            pressed: {
                alias: 'primary/pressed',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#2B4DB1',
            },
            surface: {
                alias: 'primary/surface',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#24315E',
            },
        },
        'status': {
            'caution': { alias: 'status/caution', mode: 'base-ui', value: '#FF8B1F' },
            'caution-hover': { alias: 'status/caution-hover', mode: 'base-ui', value: '#FFA23F' },
            'caution-pressed': {
                alias: 'status/caution-pressed',
                mode: 'base-ui',
                value: '#EF7D00',
            },
            'critical': { alias: 'status/critical', mode: 'base-ui', value: '#E72400' },
            'critical-hover': { alias: 'status/critical-hover', mode: 'base-ui', value: '#DC2100' },
            'critical-pressed': {
                alias: 'status/critical-pressed',
                mode: 'base-ui',
                value: '#D01F00',
            },
            'info': { alias: 'status/info', mode: 'base-ui', value: '#629BFF' },
            'info-hover': { alias: 'status/info-hover', mode: 'base-ui', value: '#6EA8FF' },
            'info-pressed': { alias: 'status/info-pressed', mode: 'base-ui', value: '#558DEF' },
            'neutral': { alias: 'status/neutral', mode: 'base-ui', value: '#9DB0C7' },
            'neutral-hover': { alias: 'status/neutral-hover', mode: 'base-ui', value: '#ABBED5' },
            'neutral-pressed': {
                alias: 'status/neutral-pressed',
                mode: 'base-ui',
                value: '#8FA2B8',
            },
            'success': { alias: 'status/success', mode: 'base-ui', value: '#54CC49' },
            'success-hover': { alias: 'status/success-hover', mode: 'base-ui', value: '#64DC58' },
            'success-pressed': {
                alias: 'status/success-pressed',
                mode: 'base-ui',
                value: '#44BD38',
            },
            'warning': { alias: 'status/warning', mode: 'base-ui', value: '#F8D41D' },
            'warning-hover': {
                alias: 'status/warning-hover',
                mode: 'base-ui',
                tenantDependent: true,
                value: '#FFE64E',
            },
            'warning-pressed': {
                alias: 'status/warning-pressed',
                mode: 'base-ui',
                value: '#E9C500',
            },
        },
        'waiting-time': {
            'border-arrivals': {
                alias: 'waiting-time/border-arrivals',
                mode: 'base-ui',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'border-departures': {
                alias: 'waiting-time/border-departures',
                mode: 'base-ui',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-departures': {
                alias: 'waiting-time/security-departures',
                mode: 'base-ui',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-transfer': {
                alias: 'waiting-time/security-transfer',
                mode: 'base-ui',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
        },
    },
    'finavia': {
        'action': {
            'default': {
                alias: 'action/default',
                mode: 'finavia',
                tenantDependent: true,
                value: '#005DE5',
                boundTo: 'primary/default',
            },
            'grey-action': {
                alias: 'action/grey-action',
                mode: 'finavia',
                value: '#8F8F92',
                boundTo: 'graphics/grey',
            },
            'grey-action-hover': {
                alias: 'action/grey-action-hover',
                mode: 'finavia',
                value: '#9B9B9E',
                boundTo: 'graphics/grey-hover',
            },
            'hover': {
                alias: 'action/hover',
                mode: 'finavia',
                tenantDependent: true,
                value: '#0C6BFA',
                boundTo: 'primary/hover',
            },
            'overlay-action': {
                alias: 'action/overlay-action',
                mode: 'finavia',
                tenantDependent: true,
                value: '#ECEEF5',
                boundTo: 'silver/100',
                boundToCollection: '_Primitives graphics',
            },
            'overlay-action-hover': {
                alias: 'action/overlay-action-hover',
                mode: 'finavia',
                tenantDependent: true,
                value: '#E2E4EB',
                boundTo: 'silver/200',
                boundToCollection: '_Primitives graphics',
            },
            'overlay-action-pressed': {
                alias: 'action/overlay-action-pressed',
                mode: 'finavia',
                tenantDependent: true,
                value: '#D5D7DE',
                boundTo: 'silver/300',
                boundToCollection: '_Primitives graphics',
            },
        },
        'background': {
            'canvas': { alias: 'background/canvas', mode: 'finavia', value: '#111114' },
            'canvas-hover': { alias: 'background/canvas-hover', mode: 'finavia', value: '#1B1B1E' },
            'canvas-pressed': {
                alias: 'background/canvas-pressed',
                mode: 'finavia',
                value: '#0A0A0D',
            },
            'elevation': { alias: 'background/elevation', mode: 'finavia', value: '#262629' },
            'elevation-hover': {
                alias: 'background/elevation-hover',
                mode: 'finavia',
                value: '#303033',
            },
            'elevation-pressed': {
                alias: 'background/elevation-pressed',
                mode: 'finavia',
                value: '#1F1F22',
            },
            'highlight': { alias: 'background/highlight', mode: 'finavia', value: '#2D2D30' },
            'highlight-hover': {
                alias: 'background/highlight-hover',
                mode: 'finavia',
                value: '#37373A',
            },
            'highlight-pressed': {
                alias: 'background/highlight-pressed',
                mode: 'finavia',
                value: '#232326',
            },
            'input': {
                alias: 'background/input',
                mode: 'finavia',
                value: '#111114',
                boundTo: 'background/canvas',
            },
            'input-hover': {
                alias: 'background/input-hover',
                mode: 'finavia',
                value: '#1B1B1E',
                boundTo: 'background/canvas-hover',
            },
            'sub-surface': { alias: 'background/sub-surface', mode: 'finavia', value: '#18181B' },
            'sub-surface-hover': {
                alias: 'background/sub-surface-hover',
                mode: 'finavia',
                value: '#222129',
            },
            'sub-surface-pressed': {
                alias: 'background/sub-surface-pressed',
                mode: 'finavia',
                value: '#111114',
            },
            'surface': { alias: 'background/surface', mode: 'finavia', value: '#1F1F22' },
            'surface-hover': {
                alias: 'background/surface-hover',
                mode: 'finavia',
                value: '#29292C',
            },
            'surface-pressed': {
                alias: 'background/surface-pressed',
                mode: 'finavia',
                value: '#18181B',
            },
        },
        'border': {
            overlay: {
                alias: 'border/overlay',
                mode: 'finavia',
                tenantDependent: true,
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            strong: { alias: 'border/strong', mode: 'finavia', value: '#505051' },
            subtle: { alias: 'border/subtle', mode: 'finavia', value: '#2A2D32' },
            transparent: { alias: 'border/transparent', mode: 'finavia', value: '#00000000' },
        },
        'charts': {
            'apron-temperature': {
                alias: 'charts/apron-temperature',
                mode: 'finavia',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'dew-point': {
                alias: 'charts/dew-point',
                mode: 'finavia',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-1': {
                alias: 'charts/level-1',
                mode: 'finavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-2': {
                alias: 'charts/level-2',
                mode: 'finavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-3': {
                alias: 'charts/level-3',
                mode: 'finavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-4': {
                alias: 'charts/level-4',
                mode: 'finavia',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain': {
                alias: 'charts/rain',
                mode: 'finavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain-snow': {
                alias: 'charts/rain-snow',
                mode: 'finavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'snow': {
                alias: 'charts/snow',
                mode: 'finavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'temperature': {
                alias: 'charts/temperature',
                mode: 'finavia',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'wind': {
                alias: 'charts/wind',
                mode: 'finavia',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'content': {
            'default': { alias: 'content/default', mode: 'finavia', value: '#E5E5E6' },
            'destructive': { alias: 'content/destructive', mode: 'finavia', value: '#FF4529' },
            'inverted': { alias: 'content/inverted', mode: 'finavia', value: '#2B2B2B' },
            'knockout': { alias: 'content/knockout', mode: 'finavia', value: '#FFFFFF' },
            'link': {
                alias: 'content/link',
                mode: 'finavia',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'link-hover': {
                alias: 'content/link-hover',
                mode: 'finavia',
                value: '#A0D2FF',
                boundTo: 'blue/300',
                boundToCollection: '_Primitives graphics',
            },
            'link-pressed': {
                alias: 'content/link-pressed',
                mode: 'finavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'link-visited': {
                alias: 'content/link-visited',
                mode: 'finavia',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'logotype': { alias: 'content/logotype', mode: 'finavia', value: '#FFFFFF' },
            'muted': { alias: 'content/muted', mode: 'finavia', value: '#ACADAF' },
            'on-action': {
                alias: 'content/on-action',
                mode: 'finavia',
                tenantDependent: true,
                value: '#ECF1F8',
                boundTo: 'content/on-primary',
            },
            'on-primary': {
                alias: 'content/on-primary',
                mode: 'finavia',
                tenantDependent: true,
                value: '#ECF1F8',
            },
        },
        'destructive': {
            border: {
                alias: 'destructive/border',
                mode: 'finavia',
                value: '#FF4529',
                boundTo: 'content/destructive',
            },
            default: {
                alias: 'destructive/default',
                mode: 'finavia',
                value: '#E72400',
                boundTo: 'status/critical',
            },
            hover: {
                alias: 'destructive/hover',
                mode: 'finavia',
                value: '#DC2100',
                boundTo: 'status/critical-hover',
            },
            pressed: {
                alias: 'destructive/pressed',
                mode: 'finavia',
                value: '#D01F00',
                boundTo: 'status/critical-pressed',
            },
        },
        'flights': {
            'arrivals': {
                alias: 'flights/arrivals',
                mode: 'finavia',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-local': {
                alias: 'flights/arrivals-local',
                mode: 'finavia',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-transfer': {
                alias: 'flights/arrivals-transfer',
                mode: 'finavia',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'cancelled': {
                alias: 'flights/cancelled',
                mode: 'finavia',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'delayed': {
                alias: 'flights/delayed',
                mode: 'finavia',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures': {
                alias: 'flights/departures',
                mode: 'finavia',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'departures-local': {
                alias: 'flights/departures-local',
                mode: 'finavia',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures-transfer': {
                alias: 'flights/departures-transfer',
                mode: 'finavia',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'on-time': {
                alias: 'flights/on-time',
                mode: 'finavia',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'focus': {
            ring: {
                alias: 'focus/ring',
                mode: 'finavia',
                tenantDependent: true,
                value: '#005DE5',
                boundTo: 'action/default',
            },
        },
        'graphics': {
            'blue': {
                alias: 'graphics/blue',
                mode: 'finavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'blue-hover': {
                alias: 'graphics/blue-hover',
                mode: 'finavia',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'blue-light': {
                alias: 'graphics/blue-light',
                mode: 'finavia',
                value: '#0B233B',
                boundTo: 'blue/900',
                boundToCollection: '_Primitives graphics',
            },
            'blue-medium': {
                alias: 'graphics/blue-medium',
                mode: 'finavia',
                value: '#437DBC',
                boundTo: 'blue/700',
                boundToCollection: '_Primitives graphics',
            },
            'blue-pressed': {
                alias: 'graphics/blue-pressed',
                mode: 'finavia',
                value: '#63A5EE',
                boundTo: 'blue/600',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey': {
                alias: 'graphics/dark-grey',
                mode: 'finavia',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-hover': {
                alias: 'graphics/dark-grey-hover',
                mode: 'finavia',
                value: '#6B6B6F',
                boundTo: 'dark-grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-pressed': {
                alias: 'graphics/dark-grey-pressed',
                mode: 'finavia',
                value: '#555558',
                boundTo: 'dark-grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'green': {
                alias: 'graphics/green',
                mode: 'finavia',
                value: '#79C379',
                boundTo: 'green/500',
                boundToCollection: '_Primitives graphics',
            },
            'green-hover': {
                alias: 'graphics/green-hover',
                mode: 'finavia',
                value: '#84CC84',
                boundTo: 'green/400',
                boundToCollection: '_Primitives graphics',
            },
            'green-pressed': {
                alias: 'graphics/green-pressed',
                mode: 'finavia',
                value: '#6DB66D',
                boundTo: 'green/600',
                boundToCollection: '_Primitives graphics',
            },
            'grey': {
                alias: 'graphics/grey',
                mode: 'finavia',
                value: '#8F8F92',
                boundTo: 'grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'grey-hover': {
                alias: 'graphics/grey-hover',
                mode: 'finavia',
                value: '#9B9B9E',
                boundTo: 'grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'grey-pressed': {
                alias: 'graphics/grey-pressed',
                mode: 'finavia',
                value: '#838386',
                boundTo: 'grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'indigo': {
                alias: 'graphics/indigo',
                mode: 'finavia',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-hover': {
                alias: 'graphics/indigo-hover',
                mode: 'finavia',
                value: '#97B4FF',
                boundTo: 'indigo/400',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-light': {
                alias: 'graphics/indigo-light',
                mode: 'finavia',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-medium': {
                alias: 'graphics/indigo-medium',
                mode: 'finavia',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-pressed': {
                alias: 'graphics/indigo-pressed',
                mode: 'finavia',
                value: '#819DF1',
                boundTo: 'indigo/600',
                boundToCollection: '_Primitives graphics',
            },
            'lavender': {
                alias: 'graphics/lavender',
                mode: 'finavia',
                value: '#BF99EF',
                boundTo: 'lavender/500',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-hover': {
                alias: 'graphics/lavender-hover',
                mode: 'finavia',
                value: '#C8A3F8',
                boundTo: 'lavender/400',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-pressed': {
                alias: 'graphics/lavender-pressed',
                mode: 'finavia',
                value: '#B38DE2',
                boundTo: 'lavender/600',
                boundToCollection: '_Primitives graphics',
            },
            'lime': {
                alias: 'graphics/lime',
                mode: 'finavia',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'lime-hover': {
                alias: 'graphics/lime-hover',
                mode: 'finavia',
                value: '#9FC76E',
                boundTo: 'lime/400',
                boundToCollection: '_Primitives graphics',
            },
            'lime-pressed': {
                alias: 'graphics/lime-pressed',
                mode: 'finavia',
                value: '#89B156',
                boundTo: 'lime/600',
                boundToCollection: '_Primitives graphics',
            },
            'orange': {
                alias: 'graphics/orange',
                mode: 'finavia',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'orange-hover': {
                alias: 'graphics/orange-hover',
                mode: 'finavia',
                value: '#F3A264',
                boundTo: 'orange/400',
                boundToCollection: '_Primitives graphics',
            },
            'orange-light': {
                alias: 'graphics/orange-light',
                mode: 'finavia',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'orange-medium': {
                alias: 'graphics/orange-medium',
                mode: 'finavia',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'orange-pressed': {
                alias: 'graphics/orange-pressed',
                mode: 'finavia',
                value: '#DC8C4B',
                boundTo: 'orange/600',
                boundToCollection: '_Primitives graphics',
            },
            'pink': {
                alias: 'graphics/pink',
                mode: 'finavia',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'pink-hover': {
                alias: 'graphics/pink-hover',
                mode: 'finavia',
                value: '#EF96CB',
                boundTo: 'pink/400',
                boundToCollection: '_Primitives graphics',
            },
            'pink-light': {
                alias: 'graphics/pink-light',
                mode: 'finavia',
                value: '#331628',
                boundTo: 'pink/900',
                boundToCollection: '_Primitives graphics',
            },
            'pink-medium': {
                alias: 'graphics/pink-medium',
                mode: 'finavia',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'pink-pressed': {
                alias: 'graphics/pink-pressed',
                mode: 'finavia',
                value: '#D880B5',
                boundTo: 'pink/600',
                boundToCollection: '_Primitives graphics',
            },
            'red': {
                alias: 'graphics/red',
                mode: 'finavia',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'red-hover': {
                alias: 'graphics/red-hover',
                mode: 'finavia',
                value: '#FD978A',
                boundTo: 'red/400',
                boundToCollection: '_Primitives graphics',
            },
            'red-pressed': {
                alias: 'graphics/red-pressed',
                mode: 'finavia',
                value: '#E68174',
                boundTo: 'red/600',
                boundToCollection: '_Primitives graphics',
            },
            'silver': {
                alias: 'graphics/silver',
                mode: 'finavia',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'silver-hover': {
                alias: 'graphics/silver-hover',
                mode: 'finavia',
                value: '#C8CAD1',
                boundTo: 'silver/400',
                boundToCollection: '_Primitives graphics',
            },
            'silver-light': {
                alias: 'graphics/silver-light',
                mode: 'finavia',
                value: '#2C2E33',
                boundTo: 'silver/900',
                boundToCollection: '_Primitives graphics',
            },
            'silver-medium': {
                alias: 'graphics/silver-medium',
                mode: 'finavia',
                value: '#8D8F95',
                boundTo: 'silver/700',
                boundToCollection: '_Primitives graphics',
            },
            'silver-pressed': {
                alias: 'graphics/silver-pressed',
                mode: 'finavia',
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            'teal': {
                alias: 'graphics/teal',
                mode: 'finavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'teal-hover': {
                alias: 'graphics/teal-hover',
                mode: 'finavia',
                value: '#30CFD1',
                boundTo: 'teal/400',
                boundToCollection: '_Primitives graphics',
            },
            'teal-light': {
                alias: 'graphics/teal-light',
                mode: 'finavia',
                value: '#00292A',
                boundTo: 'teal/900',
                boundToCollection: '_Primitives graphics',
            },
            'teal-medium': {
                alias: 'graphics/teal-medium',
                mode: 'finavia',
                value: '#008E91',
                boundTo: 'teal/700',
                boundToCollection: '_Primitives graphics',
            },
            'teal-pressed': {
                alias: 'graphics/teal-pressed',
                mode: 'finavia',
                value: '#00B9BB',
                boundTo: 'teal/600',
                boundToCollection: '_Primitives graphics',
            },
            'violet': {
                alias: 'graphics/violet',
                mode: 'finavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'violet-hover': {
                alias: 'graphics/violet-hover',
                mode: 'finavia',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'violet-light': {
                alias: 'graphics/violet-light',
                mode: 'finavia',
                value: '#241B39',
                boundTo: 'violet/900',
                boundToCollection: '_Primitives graphics',
            },
            'violet-medium': {
                alias: 'graphics/violet-medium',
                mode: 'finavia',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'violet-pressed': {
                alias: 'graphics/violet-pressed',
                mode: 'finavia',
                value: '#A990E7',
                boundTo: 'violet/600',
                boundToCollection: '_Primitives graphics',
            },
            'yellow': {
                alias: 'graphics/yellow',
                mode: 'finavia',
                value: '#D3A742',
                boundTo: 'yellow/500',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-hover': {
                alias: 'graphics/yellow-hover',
                mode: 'finavia',
                value: '#DCB151',
                boundTo: 'yellow/400',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-pressed': {
                alias: 'graphics/yellow-pressed',
                mode: 'finavia',
                value: '#C69A33',
                boundTo: 'yellow/600',
                boundToCollection: '_Primitives graphics',
            },
        },
        'primary': {
            border: {
                alias: 'primary/border',
                mode: 'finavia',
                tenantDependent: true,
                value: '#3254A7',
                boundTo: '_finavia/border',
                boundToCollection: '_BrandColors',
            },
            default: {
                alias: 'primary/default',
                mode: 'finavia',
                tenantDependent: true,
                value: '#005DE5',
                boundTo: '_finavia/default',
                boundToCollection: '_BrandColors',
            },
            hover: {
                alias: 'primary/hover',
                mode: 'finavia',
                tenantDependent: true,
                value: '#0C6BFA',
                boundTo: '_finavia/hover',
                boundToCollection: '_BrandColors',
            },
            pressed: {
                alias: 'primary/pressed',
                mode: 'finavia',
                tenantDependent: true,
                value: '#0050CF',
                boundTo: '_finavia/pressed',
                boundToCollection: '_BrandColors',
            },
            surface: {
                alias: 'primary/surface',
                mode: 'finavia',
                tenantDependent: true,
                value: '#16347A',
                boundTo: '_finavia/surface',
                boundToCollection: '_BrandColors',
            },
        },
        'status': {
            'caution': { alias: 'status/caution', mode: 'finavia', value: '#FF8B1F' },
            'caution-hover': { alias: 'status/caution-hover', mode: 'finavia', value: '#FFA23F' },
            'caution-pressed': {
                alias: 'status/caution-pressed',
                mode: 'finavia',
                value: '#EF7D00',
            },
            'critical': { alias: 'status/critical', mode: 'finavia', value: '#E72400' },
            'critical-hover': { alias: 'status/critical-hover', mode: 'finavia', value: '#DC2100' },
            'critical-pressed': {
                alias: 'status/critical-pressed',
                mode: 'finavia',
                value: '#D01F00',
            },
            'info': { alias: 'status/info', mode: 'finavia', value: '#629BFF' },
            'info-hover': { alias: 'status/info-hover', mode: 'finavia', value: '#6EA8FF' },
            'info-pressed': { alias: 'status/info-pressed', mode: 'finavia', value: '#558DEF' },
            'neutral': { alias: 'status/neutral', mode: 'finavia', value: '#9DB0C7' },
            'neutral-hover': { alias: 'status/neutral-hover', mode: 'finavia', value: '#ABBED5' },
            'neutral-pressed': {
                alias: 'status/neutral-pressed',
                mode: 'finavia',
                value: '#8FA2B8',
            },
            'success': { alias: 'status/success', mode: 'finavia', value: '#54CC49' },
            'success-hover': { alias: 'status/success-hover', mode: 'finavia', value: '#64DC58' },
            'success-pressed': {
                alias: 'status/success-pressed',
                mode: 'finavia',
                value: '#44BD38',
            },
            'warning': { alias: 'status/warning', mode: 'finavia', value: '#F8D41D' },
            'warning-hover': {
                alias: 'status/warning-hover',
                mode: 'finavia',
                tenantDependent: true,
                value: '#FFE474',
            },
            'warning-pressed': {
                alias: 'status/warning-pressed',
                mode: 'finavia',
                value: '#E9C500',
            },
        },
        'waiting-time': {
            'border-arrivals': {
                alias: 'waiting-time/border-arrivals',
                mode: 'finavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'border-departures': {
                alias: 'waiting-time/border-departures',
                mode: 'finavia',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-departures': {
                alias: 'waiting-time/security-departures',
                mode: 'finavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-transfer': {
                alias: 'waiting-time/security-transfer',
                mode: 'finavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
        },
    },
    'swedavia': {
        'action': {
            'default': {
                alias: 'action/default',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#3192D0',
                boundTo: 'primary/default',
            },
            'grey-action': {
                alias: 'action/grey-action',
                mode: 'swedavia',
                value: '#8F8F92',
                boundTo: 'graphics/grey',
            },
            'grey-action-hover': {
                alias: 'action/grey-action-hover',
                mode: 'swedavia',
                value: '#9B9B9E',
                boundTo: 'graphics/grey-hover',
            },
            'hover': {
                alias: 'action/hover',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#26AAED',
                boundTo: 'primary/hover',
            },
            'overlay-action': {
                alias: 'action/overlay-action',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#FFFFFF',
            },
            'overlay-action-hover': {
                alias: 'action/overlay-action-hover',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#FFFFFF',
            },
            'overlay-action-pressed': {
                alias: 'action/overlay-action-pressed',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#FFFFFF',
            },
        },
        'background': {
            'canvas': { alias: 'background/canvas', mode: 'swedavia', value: '#111114' },
            'canvas-hover': {
                alias: 'background/canvas-hover',
                mode: 'swedavia',
                value: '#1B1B1E',
            },
            'canvas-pressed': {
                alias: 'background/canvas-pressed',
                mode: 'swedavia',
                value: '#0A0A0D',
            },
            'elevation': { alias: 'background/elevation', mode: 'swedavia', value: '#262629' },
            'elevation-hover': {
                alias: 'background/elevation-hover',
                mode: 'swedavia',
                value: '#303033',
            },
            'elevation-pressed': {
                alias: 'background/elevation-pressed',
                mode: 'swedavia',
                value: '#1F1F22',
            },
            'highlight': { alias: 'background/highlight', mode: 'swedavia', value: '#2D2D30' },
            'highlight-hover': {
                alias: 'background/highlight-hover',
                mode: 'swedavia',
                value: '#37373A',
            },
            'highlight-pressed': {
                alias: 'background/highlight-pressed',
                mode: 'swedavia',
                value: '#232326',
            },
            'input': {
                alias: 'background/input',
                mode: 'swedavia',
                value: '#111114',
                boundTo: 'background/canvas',
            },
            'input-hover': {
                alias: 'background/input-hover',
                mode: 'swedavia',
                value: '#1B1B1E',
                boundTo: 'background/canvas-hover',
            },
            'sub-surface': { alias: 'background/sub-surface', mode: 'swedavia', value: '#18181B' },
            'sub-surface-hover': {
                alias: 'background/sub-surface-hover',
                mode: 'swedavia',
                value: '#222129',
            },
            'sub-surface-pressed': {
                alias: 'background/sub-surface-pressed',
                mode: 'swedavia',
                value: '#111114',
            },
            'surface': { alias: 'background/surface', mode: 'swedavia', value: '#1F1F22' },
            'surface-hover': {
                alias: 'background/surface-hover',
                mode: 'swedavia',
                value: '#29292C',
            },
            'surface-pressed': {
                alias: 'background/surface-pressed',
                mode: 'swedavia',
                value: '#18181B',
            },
        },
        'border': {
            overlay: {
                alias: 'border/overlay',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#FFFFFF',
            },
            strong: { alias: 'border/strong', mode: 'swedavia', value: '#505051' },
            subtle: { alias: 'border/subtle', mode: 'swedavia', value: '#2A2D32' },
            transparent: { alias: 'border/transparent', mode: 'swedavia', value: '#00000000' },
        },
        'charts': {
            'apron-temperature': {
                alias: 'charts/apron-temperature',
                mode: 'swedavia',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'dew-point': {
                alias: 'charts/dew-point',
                mode: 'swedavia',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-1': {
                alias: 'charts/level-1',
                mode: 'swedavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-2': {
                alias: 'charts/level-2',
                mode: 'swedavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-3': {
                alias: 'charts/level-3',
                mode: 'swedavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-4': {
                alias: 'charts/level-4',
                mode: 'swedavia',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain': {
                alias: 'charts/rain',
                mode: 'swedavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain-snow': {
                alias: 'charts/rain-snow',
                mode: 'swedavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'snow': {
                alias: 'charts/snow',
                mode: 'swedavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'temperature': {
                alias: 'charts/temperature',
                mode: 'swedavia',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'wind': {
                alias: 'charts/wind',
                mode: 'swedavia',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'content': {
            'default': { alias: 'content/default', mode: 'swedavia', value: '#E5E5E6' },
            'destructive': { alias: 'content/destructive', mode: 'swedavia', value: '#FF4529' },
            'inverted': { alias: 'content/inverted', mode: 'swedavia', value: '#2B2B2B' },
            'knockout': { alias: 'content/knockout', mode: 'swedavia', value: '#FFFFFF' },
            'link': {
                alias: 'content/link',
                mode: 'swedavia',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'link-hover': {
                alias: 'content/link-hover',
                mode: 'swedavia',
                value: '#A0D2FF',
                boundTo: 'blue/300',
                boundToCollection: '_Primitives graphics',
            },
            'link-pressed': {
                alias: 'content/link-pressed',
                mode: 'swedavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'link-visited': {
                alias: 'content/link-visited',
                mode: 'swedavia',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'logotype': { alias: 'content/logotype', mode: 'swedavia', value: '#FFFFFF' },
            'muted': { alias: 'content/muted', mode: 'swedavia', value: '#ACADAF' },
            'on-action': {
                alias: 'content/on-action',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#2B2B2B',
                boundTo: 'content/on-primary',
            },
            'on-primary': {
                alias: 'content/on-primary',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#2B2B2B',
            },
        },
        'destructive': {
            border: {
                alias: 'destructive/border',
                mode: 'swedavia',
                value: '#FF4529',
                boundTo: 'content/destructive',
            },
            default: {
                alias: 'destructive/default',
                mode: 'swedavia',
                value: '#E72400',
                boundTo: 'status/critical',
            },
            hover: {
                alias: 'destructive/hover',
                mode: 'swedavia',
                value: '#DC2100',
                boundTo: 'status/critical-hover',
            },
            pressed: {
                alias: 'destructive/pressed',
                mode: 'swedavia',
                value: '#D01F00',
                boundTo: 'status/critical-pressed',
            },
        },
        'flights': {
            'arrivals': {
                alias: 'flights/arrivals',
                mode: 'swedavia',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-local': {
                alias: 'flights/arrivals-local',
                mode: 'swedavia',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-transfer': {
                alias: 'flights/arrivals-transfer',
                mode: 'swedavia',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'cancelled': {
                alias: 'flights/cancelled',
                mode: 'swedavia',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'delayed': {
                alias: 'flights/delayed',
                mode: 'swedavia',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures': {
                alias: 'flights/departures',
                mode: 'swedavia',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'departures-local': {
                alias: 'flights/departures-local',
                mode: 'swedavia',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures-transfer': {
                alias: 'flights/departures-transfer',
                mode: 'swedavia',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'on-time': {
                alias: 'flights/on-time',
                mode: 'swedavia',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'focus': {
            ring: {
                alias: 'focus/ring',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#3192D0',
                boundTo: 'action/default',
            },
        },
        'graphics': {
            'blue': {
                alias: 'graphics/blue',
                mode: 'swedavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'blue-hover': {
                alias: 'graphics/blue-hover',
                mode: 'swedavia',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'blue-light': {
                alias: 'graphics/blue-light',
                mode: 'swedavia',
                value: '#0B233B',
                boundTo: 'blue/900',
                boundToCollection: '_Primitives graphics',
            },
            'blue-medium': {
                alias: 'graphics/blue-medium',
                mode: 'swedavia',
                value: '#437DBC',
                boundTo: 'blue/700',
                boundToCollection: '_Primitives graphics',
            },
            'blue-pressed': {
                alias: 'graphics/blue-pressed',
                mode: 'swedavia',
                value: '#63A5EE',
                boundTo: 'blue/600',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey': {
                alias: 'graphics/dark-grey',
                mode: 'swedavia',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-hover': {
                alias: 'graphics/dark-grey-hover',
                mode: 'swedavia',
                value: '#6B6B6F',
                boundTo: 'dark-grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-pressed': {
                alias: 'graphics/dark-grey-pressed',
                mode: 'swedavia',
                value: '#555558',
                boundTo: 'dark-grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'green': {
                alias: 'graphics/green',
                mode: 'swedavia',
                value: '#79C379',
                boundTo: 'green/500',
                boundToCollection: '_Primitives graphics',
            },
            'green-hover': {
                alias: 'graphics/green-hover',
                mode: 'swedavia',
                value: '#84CC84',
                boundTo: 'green/400',
                boundToCollection: '_Primitives graphics',
            },
            'green-pressed': {
                alias: 'graphics/green-pressed',
                mode: 'swedavia',
                value: '#6DB66D',
                boundTo: 'green/600',
                boundToCollection: '_Primitives graphics',
            },
            'grey': {
                alias: 'graphics/grey',
                mode: 'swedavia',
                value: '#8F8F92',
                boundTo: 'grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'grey-hover': {
                alias: 'graphics/grey-hover',
                mode: 'swedavia',
                value: '#9B9B9E',
                boundTo: 'grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'grey-pressed': {
                alias: 'graphics/grey-pressed',
                mode: 'swedavia',
                value: '#838386',
                boundTo: 'grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'indigo': {
                alias: 'graphics/indigo',
                mode: 'swedavia',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-hover': {
                alias: 'graphics/indigo-hover',
                mode: 'swedavia',
                value: '#97B4FF',
                boundTo: 'indigo/400',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-light': {
                alias: 'graphics/indigo-light',
                mode: 'swedavia',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-medium': {
                alias: 'graphics/indigo-medium',
                mode: 'swedavia',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-pressed': {
                alias: 'graphics/indigo-pressed',
                mode: 'swedavia',
                value: '#819DF1',
                boundTo: 'indigo/600',
                boundToCollection: '_Primitives graphics',
            },
            'lavender': {
                alias: 'graphics/lavender',
                mode: 'swedavia',
                value: '#BF99EF',
                boundTo: 'lavender/500',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-hover': {
                alias: 'graphics/lavender-hover',
                mode: 'swedavia',
                value: '#C8A3F8',
                boundTo: 'lavender/400',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-pressed': {
                alias: 'graphics/lavender-pressed',
                mode: 'swedavia',
                value: '#B38DE2',
                boundTo: 'lavender/600',
                boundToCollection: '_Primitives graphics',
            },
            'lime': {
                alias: 'graphics/lime',
                mode: 'swedavia',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'lime-hover': {
                alias: 'graphics/lime-hover',
                mode: 'swedavia',
                value: '#9FC76E',
                boundTo: 'lime/400',
                boundToCollection: '_Primitives graphics',
            },
            'lime-pressed': {
                alias: 'graphics/lime-pressed',
                mode: 'swedavia',
                value: '#89B156',
                boundTo: 'lime/600',
                boundToCollection: '_Primitives graphics',
            },
            'orange': {
                alias: 'graphics/orange',
                mode: 'swedavia',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'orange-hover': {
                alias: 'graphics/orange-hover',
                mode: 'swedavia',
                value: '#F3A264',
                boundTo: 'orange/400',
                boundToCollection: '_Primitives graphics',
            },
            'orange-light': {
                alias: 'graphics/orange-light',
                mode: 'swedavia',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'orange-medium': {
                alias: 'graphics/orange-medium',
                mode: 'swedavia',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'orange-pressed': {
                alias: 'graphics/orange-pressed',
                mode: 'swedavia',
                value: '#DC8C4B',
                boundTo: 'orange/600',
                boundToCollection: '_Primitives graphics',
            },
            'pink': {
                alias: 'graphics/pink',
                mode: 'swedavia',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'pink-hover': {
                alias: 'graphics/pink-hover',
                mode: 'swedavia',
                value: '#EF96CB',
                boundTo: 'pink/400',
                boundToCollection: '_Primitives graphics',
            },
            'pink-light': {
                alias: 'graphics/pink-light',
                mode: 'swedavia',
                value: '#331628',
                boundTo: 'pink/900',
                boundToCollection: '_Primitives graphics',
            },
            'pink-medium': {
                alias: 'graphics/pink-medium',
                mode: 'swedavia',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'pink-pressed': {
                alias: 'graphics/pink-pressed',
                mode: 'swedavia',
                value: '#D880B5',
                boundTo: 'pink/600',
                boundToCollection: '_Primitives graphics',
            },
            'red': {
                alias: 'graphics/red',
                mode: 'swedavia',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'red-hover': {
                alias: 'graphics/red-hover',
                mode: 'swedavia',
                value: '#FD978A',
                boundTo: 'red/400',
                boundToCollection: '_Primitives graphics',
            },
            'red-pressed': {
                alias: 'graphics/red-pressed',
                mode: 'swedavia',
                value: '#E68174',
                boundTo: 'red/600',
                boundToCollection: '_Primitives graphics',
            },
            'silver': {
                alias: 'graphics/silver',
                mode: 'swedavia',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'silver-hover': {
                alias: 'graphics/silver-hover',
                mode: 'swedavia',
                value: '#C8CAD1',
                boundTo: 'silver/400',
                boundToCollection: '_Primitives graphics',
            },
            'silver-light': {
                alias: 'graphics/silver-light',
                mode: 'swedavia',
                value: '#2C2E33',
                boundTo: 'silver/900',
                boundToCollection: '_Primitives graphics',
            },
            'silver-medium': {
                alias: 'graphics/silver-medium',
                mode: 'swedavia',
                value: '#8D8F95',
                boundTo: 'silver/700',
                boundToCollection: '_Primitives graphics',
            },
            'silver-pressed': {
                alias: 'graphics/silver-pressed',
                mode: 'swedavia',
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            'teal': {
                alias: 'graphics/teal',
                mode: 'swedavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'teal-hover': {
                alias: 'graphics/teal-hover',
                mode: 'swedavia',
                value: '#30CFD1',
                boundTo: 'teal/400',
                boundToCollection: '_Primitives graphics',
            },
            'teal-light': {
                alias: 'graphics/teal-light',
                mode: 'swedavia',
                value: '#00292A',
                boundTo: 'teal/900',
                boundToCollection: '_Primitives graphics',
            },
            'teal-medium': {
                alias: 'graphics/teal-medium',
                mode: 'swedavia',
                value: '#008E91',
                boundTo: 'teal/700',
                boundToCollection: '_Primitives graphics',
            },
            'teal-pressed': {
                alias: 'graphics/teal-pressed',
                mode: 'swedavia',
                value: '#00B9BB',
                boundTo: 'teal/600',
                boundToCollection: '_Primitives graphics',
            },
            'violet': {
                alias: 'graphics/violet',
                mode: 'swedavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'violet-hover': {
                alias: 'graphics/violet-hover',
                mode: 'swedavia',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'violet-light': {
                alias: 'graphics/violet-light',
                mode: 'swedavia',
                value: '#241B39',
                boundTo: 'violet/900',
                boundToCollection: '_Primitives graphics',
            },
            'violet-medium': {
                alias: 'graphics/violet-medium',
                mode: 'swedavia',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'violet-pressed': {
                alias: 'graphics/violet-pressed',
                mode: 'swedavia',
                value: '#A990E7',
                boundTo: 'violet/600',
                boundToCollection: '_Primitives graphics',
            },
            'yellow': {
                alias: 'graphics/yellow',
                mode: 'swedavia',
                value: '#D3A742',
                boundTo: 'yellow/500',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-hover': {
                alias: 'graphics/yellow-hover',
                mode: 'swedavia',
                value: '#DCB151',
                boundTo: 'yellow/400',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-pressed': {
                alias: 'graphics/yellow-pressed',
                mode: 'swedavia',
                value: '#C69A33',
                boundTo: 'yellow/600',
                boundToCollection: '_Primitives graphics',
            },
        },
        'primary': {
            border: {
                alias: 'primary/border',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#008ACB',
                boundTo: '_swedavia/border',
                boundToCollection: '_BrandColors',
            },
            default: {
                alias: 'primary/default',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#3192D0',
                boundTo: '_swedavia/default',
                boundToCollection: '_BrandColors',
            },
            hover: {
                alias: 'primary/hover',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#26AAED',
                boundTo: '_swedavia/hover',
                boundToCollection: '_BrandColors',
            },
            pressed: {
                alias: 'primary/pressed',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#008ECF',
                boundTo: '_swedavia/pressed',
                boundToCollection: '_BrandColors',
            },
            surface: {
                alias: 'primary/surface',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#1F3D50',
                boundTo: '_swedavia/surface',
                boundToCollection: '_BrandColors',
            },
        },
        'status': {
            'caution': { alias: 'status/caution', mode: 'swedavia', value: '#FF8B1F' },
            'caution-hover': { alias: 'status/caution-hover', mode: 'swedavia', value: '#FFA23F' },
            'caution-pressed': {
                alias: 'status/caution-pressed',
                mode: 'swedavia',
                value: '#EF7D00',
            },
            'critical': { alias: 'status/critical', mode: 'swedavia', value: '#E72400' },
            'critical-hover': {
                alias: 'status/critical-hover',
                mode: 'swedavia',
                value: '#DC2100',
            },
            'critical-pressed': {
                alias: 'status/critical-pressed',
                mode: 'swedavia',
                value: '#D01F00',
            },
            'info': { alias: 'status/info', mode: 'swedavia', value: '#629BFF' },
            'info-hover': { alias: 'status/info-hover', mode: 'swedavia', value: '#6EA8FF' },
            'info-pressed': { alias: 'status/info-pressed', mode: 'swedavia', value: '#558DEF' },
            'neutral': { alias: 'status/neutral', mode: 'swedavia', value: '#9DB0C7' },
            'neutral-hover': { alias: 'status/neutral-hover', mode: 'swedavia', value: '#ABBED5' },
            'neutral-pressed': {
                alias: 'status/neutral-pressed',
                mode: 'swedavia',
                value: '#8FA2B8',
            },
            'success': { alias: 'status/success', mode: 'swedavia', value: '#54CC49' },
            'success-hover': { alias: 'status/success-hover', mode: 'swedavia', value: '#64DC58' },
            'success-pressed': {
                alias: 'status/success-pressed',
                mode: 'swedavia',
                value: '#44BD38',
            },
            'warning': { alias: 'status/warning', mode: 'swedavia', value: '#F8D41D' },
            'warning-hover': {
                alias: 'status/warning-hover',
                mode: 'swedavia',
                tenantDependent: true,
                value: '#FFE64E',
            },
            'warning-pressed': {
                alias: 'status/warning-pressed',
                mode: 'swedavia',
                value: '#E9C500',
            },
        },
        'waiting-time': {
            'border-arrivals': {
                alias: 'waiting-time/border-arrivals',
                mode: 'swedavia',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'border-departures': {
                alias: 'waiting-time/border-departures',
                mode: 'swedavia',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-departures': {
                alias: 'waiting-time/security-departures',
                mode: 'swedavia',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-transfer': {
                alias: 'waiting-time/security-transfer',
                mode: 'swedavia',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
        },
    },
    'tallinn': {
        'action': {
            'default': {
                alias: 'action/default',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#FFDD4F',
                boundTo: 'primary/default',
            },
            'grey-action': {
                alias: 'action/grey-action',
                mode: 'tallinn',
                value: '#8F8F92',
                boundTo: 'graphics/grey',
            },
            'grey-action-hover': {
                alias: 'action/grey-action-hover',
                mode: 'tallinn',
                value: '#9B9B9E',
                boundTo: 'graphics/grey-hover',
            },
            'hover': {
                alias: 'action/hover',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#FFEC61',
                boundTo: 'primary/hover',
            },
            'overlay-action': {
                alias: 'action/overlay-action',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#ECEEF5',
                boundTo: 'silver/100',
                boundToCollection: '_Primitives graphics',
            },
            'overlay-action-hover': {
                alias: 'action/overlay-action-hover',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#E2E4EB',
                boundTo: 'silver/200',
                boundToCollection: '_Primitives graphics',
            },
            'overlay-action-pressed': {
                alias: 'action/overlay-action-pressed',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#D5D7DE',
                boundTo: 'silver/300',
                boundToCollection: '_Primitives graphics',
            },
        },
        'background': {
            'canvas': { alias: 'background/canvas', mode: 'tallinn', value: '#111114' },
            'canvas-hover': { alias: 'background/canvas-hover', mode: 'tallinn', value: '#1B1B1E' },
            'canvas-pressed': {
                alias: 'background/canvas-pressed',
                mode: 'tallinn',
                value: '#0A0A0D',
            },
            'elevation': { alias: 'background/elevation', mode: 'tallinn', value: '#262629' },
            'elevation-hover': {
                alias: 'background/elevation-hover',
                mode: 'tallinn',
                value: '#303033',
            },
            'elevation-pressed': {
                alias: 'background/elevation-pressed',
                mode: 'tallinn',
                value: '#1F1F22',
            },
            'highlight': { alias: 'background/highlight', mode: 'tallinn', value: '#2D2D30' },
            'highlight-hover': {
                alias: 'background/highlight-hover',
                mode: 'tallinn',
                value: '#37373A',
            },
            'highlight-pressed': {
                alias: 'background/highlight-pressed',
                mode: 'tallinn',
                value: '#232326',
            },
            'input': {
                alias: 'background/input',
                mode: 'tallinn',
                value: '#111114',
                boundTo: 'background/canvas',
            },
            'input-hover': {
                alias: 'background/input-hover',
                mode: 'tallinn',
                value: '#1B1B1E',
                boundTo: 'background/canvas-hover',
            },
            'sub-surface': { alias: 'background/sub-surface', mode: 'tallinn', value: '#18181B' },
            'sub-surface-hover': {
                alias: 'background/sub-surface-hover',
                mode: 'tallinn',
                value: '#222129',
            },
            'sub-surface-pressed': {
                alias: 'background/sub-surface-pressed',
                mode: 'tallinn',
                value: '#111114',
            },
            'surface': { alias: 'background/surface', mode: 'tallinn', value: '#1F1F22' },
            'surface-hover': {
                alias: 'background/surface-hover',
                mode: 'tallinn',
                value: '#29292C',
            },
            'surface-pressed': {
                alias: 'background/surface-pressed',
                mode: 'tallinn',
                value: '#18181B',
            },
        },
        'border': {
            overlay: {
                alias: 'border/overlay',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            strong: { alias: 'border/strong', mode: 'tallinn', value: '#505051' },
            subtle: { alias: 'border/subtle', mode: 'tallinn', value: '#2A2D32' },
            transparent: { alias: 'border/transparent', mode: 'tallinn', value: '#00000000' },
        },
        'charts': {
            'apron-temperature': {
                alias: 'charts/apron-temperature',
                mode: 'tallinn',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'dew-point': {
                alias: 'charts/dew-point',
                mode: 'tallinn',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-1': {
                alias: 'charts/level-1',
                mode: 'tallinn',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-2': {
                alias: 'charts/level-2',
                mode: 'tallinn',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-3': {
                alias: 'charts/level-3',
                mode: 'tallinn',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'level-4': {
                alias: 'charts/level-4',
                mode: 'tallinn',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain': {
                alias: 'charts/rain',
                mode: 'tallinn',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'rain-snow': {
                alias: 'charts/rain-snow',
                mode: 'tallinn',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'snow': {
                alias: 'charts/snow',
                mode: 'tallinn',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'temperature': {
                alias: 'charts/temperature',
                mode: 'tallinn',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'wind': {
                alias: 'charts/wind',
                mode: 'tallinn',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'content': {
            'default': { alias: 'content/default', mode: 'tallinn', value: '#E5E5E6' },
            'destructive': { alias: 'content/destructive', mode: 'tallinn', value: '#FF4529' },
            'inverted': { alias: 'content/inverted', mode: 'tallinn', value: '#2B2B2B' },
            'knockout': { alias: 'content/knockout', mode: 'tallinn', value: '#FFFFFF' },
            'link': {
                alias: 'content/link',
                mode: 'tallinn',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'link-hover': {
                alias: 'content/link-hover',
                mode: 'tallinn',
                value: '#A0D2FF',
                boundTo: 'blue/300',
                boundToCollection: '_Primitives graphics',
            },
            'link-pressed': {
                alias: 'content/link-pressed',
                mode: 'tallinn',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'link-visited': {
                alias: 'content/link-visited',
                mode: 'tallinn',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'logotype': { alias: 'content/logotype', mode: 'tallinn', value: '#FFFFFF' },
            'muted': { alias: 'content/muted', mode: 'tallinn', value: '#ACADAF' },
            'on-action': {
                alias: 'content/on-action',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#2B2B2B',
                boundTo: 'content/on-primary',
            },
            'on-primary': {
                alias: 'content/on-primary',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#2B2B2B',
            },
        },
        'destructive': {
            border: {
                alias: 'destructive/border',
                mode: 'tallinn',
                value: '#FF4529',
                boundTo: 'content/destructive',
            },
            default: {
                alias: 'destructive/default',
                mode: 'tallinn',
                value: '#E72400',
                boundTo: 'status/critical',
            },
            hover: {
                alias: 'destructive/hover',
                mode: 'tallinn',
                value: '#DC2100',
                boundTo: 'status/critical-hover',
            },
            pressed: {
                alias: 'destructive/pressed',
                mode: 'tallinn',
                value: '#D01F00',
                boundTo: 'status/critical-pressed',
            },
        },
        'flights': {
            'arrivals': {
                alias: 'flights/arrivals',
                mode: 'tallinn',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-local': {
                alias: 'flights/arrivals-local',
                mode: 'tallinn',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'arrivals-transfer': {
                alias: 'flights/arrivals-transfer',
                mode: 'tallinn',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'cancelled': {
                alias: 'flights/cancelled',
                mode: 'tallinn',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'delayed': {
                alias: 'flights/delayed',
                mode: 'tallinn',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures': {
                alias: 'flights/departures',
                mode: 'tallinn',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'departures-local': {
                alias: 'flights/departures-local',
                mode: 'tallinn',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'departures-transfer': {
                alias: 'flights/departures-transfer',
                mode: 'tallinn',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'on-time': {
                alias: 'flights/on-time',
                mode: 'tallinn',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
        },
        'focus': {
            ring: {
                alias: 'focus/ring',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#FFDD4F',
                boundTo: 'action/default',
            },
        },
        'graphics': {
            'blue': {
                alias: 'graphics/blue',
                mode: 'tallinn',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'blue-hover': {
                alias: 'graphics/blue-hover',
                mode: 'tallinn',
                value: '#7BBCFF',
                boundTo: 'blue/400',
                boundToCollection: '_Primitives graphics',
            },
            'blue-light': {
                alias: 'graphics/blue-light',
                mode: 'tallinn',
                value: '#0B233B',
                boundTo: 'blue/900',
                boundToCollection: '_Primitives graphics',
            },
            'blue-medium': {
                alias: 'graphics/blue-medium',
                mode: 'tallinn',
                value: '#437DBC',
                boundTo: 'blue/700',
                boundToCollection: '_Primitives graphics',
            },
            'blue-pressed': {
                alias: 'graphics/blue-pressed',
                mode: 'tallinn',
                value: '#63A5EE',
                boundTo: 'blue/600',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey': {
                alias: 'graphics/dark-grey',
                mode: 'tallinn',
                value: '#606063',
                boundTo: 'dark-grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-hover': {
                alias: 'graphics/dark-grey-hover',
                mode: 'tallinn',
                value: '#6B6B6F',
                boundTo: 'dark-grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'dark-grey-pressed': {
                alias: 'graphics/dark-grey-pressed',
                mode: 'tallinn',
                value: '#555558',
                boundTo: 'dark-grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'green': {
                alias: 'graphics/green',
                mode: 'tallinn',
                value: '#79C379',
                boundTo: 'green/500',
                boundToCollection: '_Primitives graphics',
            },
            'green-hover': {
                alias: 'graphics/green-hover',
                mode: 'tallinn',
                value: '#84CC84',
                boundTo: 'green/400',
                boundToCollection: '_Primitives graphics',
            },
            'green-pressed': {
                alias: 'graphics/green-pressed',
                mode: 'tallinn',
                value: '#6DB66D',
                boundTo: 'green/600',
                boundToCollection: '_Primitives graphics',
            },
            'grey': {
                alias: 'graphics/grey',
                mode: 'tallinn',
                value: '#8F8F92',
                boundTo: 'grey/500',
                boundToCollection: '_Primitives graphics',
            },
            'grey-hover': {
                alias: 'graphics/grey-hover',
                mode: 'tallinn',
                value: '#9B9B9E',
                boundTo: 'grey/400',
                boundToCollection: '_Primitives graphics',
            },
            'grey-pressed': {
                alias: 'graphics/grey-pressed',
                mode: 'tallinn',
                value: '#838386',
                boundTo: 'grey/600',
                boundToCollection: '_Primitives graphics',
            },
            'indigo': {
                alias: 'graphics/indigo',
                mode: 'tallinn',
                value: '#8DAAFF',
                boundTo: 'indigo/500',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-hover': {
                alias: 'graphics/indigo-hover',
                mode: 'tallinn',
                value: '#97B4FF',
                boundTo: 'indigo/400',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-light': {
                alias: 'graphics/indigo-light',
                mode: 'tallinn',
                value: '#17203C',
                boundTo: 'indigo/900',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-medium': {
                alias: 'graphics/indigo-medium',
                mode: 'tallinn',
                value: '#5E76BE',
                boundTo: 'indigo/700',
                boundToCollection: '_Primitives graphics',
            },
            'indigo-pressed': {
                alias: 'graphics/indigo-pressed',
                mode: 'tallinn',
                value: '#819DF1',
                boundTo: 'indigo/600',
                boundToCollection: '_Primitives graphics',
            },
            'lavender': {
                alias: 'graphics/lavender',
                mode: 'tallinn',
                value: '#BF99EF',
                boundTo: 'lavender/500',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-hover': {
                alias: 'graphics/lavender-hover',
                mode: 'tallinn',
                value: '#C8A3F8',
                boundTo: 'lavender/400',
                boundToCollection: '_Primitives graphics',
            },
            'lavender-pressed': {
                alias: 'graphics/lavender-pressed',
                mode: 'tallinn',
                value: '#B38DE2',
                boundTo: 'lavender/600',
                boundToCollection: '_Primitives graphics',
            },
            'lime': {
                alias: 'graphics/lime',
                mode: 'tallinn',
                value: '#95BD63',
                boundTo: 'lime/500',
                boundToCollection: '_Primitives graphics',
            },
            'lime-hover': {
                alias: 'graphics/lime-hover',
                mode: 'tallinn',
                value: '#9FC76E',
                boundTo: 'lime/400',
                boundToCollection: '_Primitives graphics',
            },
            'lime-pressed': {
                alias: 'graphics/lime-pressed',
                mode: 'tallinn',
                value: '#89B156',
                boundTo: 'lime/600',
                boundToCollection: '_Primitives graphics',
            },
            'orange': {
                alias: 'graphics/orange',
                mode: 'tallinn',
                value: '#EA9858',
                boundTo: 'orange/500',
                boundToCollection: '_Primitives graphics',
            },
            'orange-hover': {
                alias: 'graphics/orange-hover',
                mode: 'tallinn',
                value: '#F3A264',
                boundTo: 'orange/400',
                boundToCollection: '_Primitives graphics',
            },
            'orange-light': {
                alias: 'graphics/orange-light',
                mode: 'tallinn',
                value: '#351A03',
                boundTo: 'orange/900',
                boundToCollection: '_Primitives graphics',
            },
            'orange-medium': {
                alias: 'graphics/orange-medium',
                mode: 'tallinn',
                value: '#AC672D',
                boundTo: 'orange/700',
                boundToCollection: '_Primitives graphics',
            },
            'orange-pressed': {
                alias: 'graphics/orange-pressed',
                mode: 'tallinn',
                value: '#DC8C4B',
                boundTo: 'orange/600',
                boundToCollection: '_Primitives graphics',
            },
            'pink': {
                alias: 'graphics/pink',
                mode: 'tallinn',
                value: '#E68CC2',
                boundTo: 'pink/500',
                boundToCollection: '_Primitives graphics',
            },
            'pink-hover': {
                alias: 'graphics/pink-hover',
                mode: 'tallinn',
                value: '#EF96CB',
                boundTo: 'pink/400',
                boundToCollection: '_Primitives graphics',
            },
            'pink-light': {
                alias: 'graphics/pink-light',
                mode: 'tallinn',
                value: '#331628',
                boundTo: 'pink/900',
                boundToCollection: '_Primitives graphics',
            },
            'pink-medium': {
                alias: 'graphics/pink-medium',
                mode: 'tallinn',
                value: '#A95D8B',
                boundTo: 'pink/700',
                boundToCollection: '_Primitives graphics',
            },
            'pink-pressed': {
                alias: 'graphics/pink-pressed',
                mode: 'tallinn',
                value: '#D880B5',
                boundTo: 'pink/600',
                boundToCollection: '_Primitives graphics',
            },
            'red': {
                alias: 'graphics/red',
                mode: 'tallinn',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'red-hover': {
                alias: 'graphics/red-hover',
                mode: 'tallinn',
                value: '#FD978A',
                boundTo: 'red/400',
                boundToCollection: '_Primitives graphics',
            },
            'red-pressed': {
                alias: 'graphics/red-pressed',
                mode: 'tallinn',
                value: '#E68174',
                boundTo: 'red/600',
                boundToCollection: '_Primitives graphics',
            },
            'silver': {
                alias: 'graphics/silver',
                mode: 'tallinn',
                value: '#BBBDC4',
                boundTo: 'silver/500',
                boundToCollection: '_Primitives graphics',
            },
            'silver-hover': {
                alias: 'graphics/silver-hover',
                mode: 'tallinn',
                value: '#C8CAD1',
                boundTo: 'silver/400',
                boundToCollection: '_Primitives graphics',
            },
            'silver-light': {
                alias: 'graphics/silver-light',
                mode: 'tallinn',
                value: '#2C2E33',
                boundTo: 'silver/900',
                boundToCollection: '_Primitives graphics',
            },
            'silver-medium': {
                alias: 'graphics/silver-medium',
                mode: 'tallinn',
                value: '#8D8F95',
                boundTo: 'silver/700',
                boundToCollection: '_Primitives graphics',
            },
            'silver-pressed': {
                alias: 'graphics/silver-pressed',
                mode: 'tallinn',
                value: '#AFB1B8',
                boundTo: 'silver/600',
                boundToCollection: '_Primitives graphics',
            },
            'teal': {
                alias: 'graphics/teal',
                mode: 'tallinn',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
            'teal-hover': {
                alias: 'graphics/teal-hover',
                mode: 'tallinn',
                value: '#30CFD1',
                boundTo: 'teal/400',
                boundToCollection: '_Primitives graphics',
            },
            'teal-light': {
                alias: 'graphics/teal-light',
                mode: 'tallinn',
                value: '#00292A',
                boundTo: 'teal/900',
                boundToCollection: '_Primitives graphics',
            },
            'teal-medium': {
                alias: 'graphics/teal-medium',
                mode: 'tallinn',
                value: '#008E91',
                boundTo: 'teal/700',
                boundToCollection: '_Primitives graphics',
            },
            'teal-pressed': {
                alias: 'graphics/teal-pressed',
                mode: 'tallinn',
                value: '#00B9BB',
                boundTo: 'teal/600',
                boundToCollection: '_Primitives graphics',
            },
            'violet': {
                alias: 'graphics/violet',
                mode: 'tallinn',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'violet-hover': {
                alias: 'graphics/violet-hover',
                mode: 'tallinn',
                value: '#BFA6FE',
                boundTo: 'violet/400',
                boundToCollection: '_Primitives graphics',
            },
            'violet-light': {
                alias: 'graphics/violet-light',
                mode: 'tallinn',
                value: '#241B39',
                boundTo: 'violet/900',
                boundToCollection: '_Primitives graphics',
            },
            'violet-medium': {
                alias: 'graphics/violet-medium',
                mode: 'tallinn',
                value: '#816BB6',
                boundTo: 'violet/700',
                boundToCollection: '_Primitives graphics',
            },
            'violet-pressed': {
                alias: 'graphics/violet-pressed',
                mode: 'tallinn',
                value: '#A990E7',
                boundTo: 'violet/600',
                boundToCollection: '_Primitives graphics',
            },
            'yellow': {
                alias: 'graphics/yellow',
                mode: 'tallinn',
                value: '#D3A742',
                boundTo: 'yellow/500',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-hover': {
                alias: 'graphics/yellow-hover',
                mode: 'tallinn',
                value: '#DCB151',
                boundTo: 'yellow/400',
                boundToCollection: '_Primitives graphics',
            },
            'yellow-pressed': {
                alias: 'graphics/yellow-pressed',
                mode: 'tallinn',
                value: '#C69A33',
                boundTo: 'yellow/600',
                boundToCollection: '_Primitives graphics',
            },
        },
        'primary': {
            border: {
                alias: 'primary/border',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#615823',
                boundTo: '_tallinn/border',
                boundToCollection: '_BrandColors',
            },
            default: {
                alias: 'primary/default',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#FFDD4F',
                boundTo: '_tallinn/default',
                boundToCollection: '_BrandColors',
            },
            hover: {
                alias: 'primary/hover',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#FFEC61',
                boundTo: '_tallinn/hover',
                boundToCollection: '_BrandColors',
            },
            pressed: {
                alias: 'primary/pressed',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#F0CE3C',
                boundTo: '_tallinn/pressed',
                boundToCollection: '_BrandColors',
            },
            surface: {
                alias: 'primary/surface',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#272417',
                boundTo: '_tallinn/surface',
                boundToCollection: '_BrandColors',
            },
        },
        'status': {
            'caution': { alias: 'status/caution', mode: 'tallinn', value: '#FF8B1F' },
            'caution-hover': { alias: 'status/caution-hover', mode: 'tallinn', value: '#FFA23F' },
            'caution-pressed': {
                alias: 'status/caution-pressed',
                mode: 'tallinn',
                value: '#EF7D00',
            },
            'critical': { alias: 'status/critical', mode: 'tallinn', value: '#E72400' },
            'critical-hover': { alias: 'status/critical-hover', mode: 'tallinn', value: '#DC2100' },
            'critical-pressed': {
                alias: 'status/critical-pressed',
                mode: 'tallinn',
                value: '#D01F00',
            },
            'info': { alias: 'status/info', mode: 'tallinn', value: '#629BFF' },
            'info-hover': { alias: 'status/info-hover', mode: 'tallinn', value: '#6EA8FF' },
            'info-pressed': { alias: 'status/info-pressed', mode: 'tallinn', value: '#558DEF' },
            'neutral': { alias: 'status/neutral', mode: 'tallinn', value: '#9DB0C7' },
            'neutral-hover': { alias: 'status/neutral-hover', mode: 'tallinn', value: '#ABBED5' },
            'neutral-pressed': {
                alias: 'status/neutral-pressed',
                mode: 'tallinn',
                value: '#8FA2B8',
            },
            'success': { alias: 'status/success', mode: 'tallinn', value: '#54CC49' },
            'success-hover': { alias: 'status/success-hover', mode: 'tallinn', value: '#64DC58' },
            'success-pressed': {
                alias: 'status/success-pressed',
                mode: 'tallinn',
                value: '#44BD38',
            },
            'warning': { alias: 'status/warning', mode: 'tallinn', value: '#F8D41D' },
            'warning-hover': {
                alias: 'status/warning-hover',
                mode: 'tallinn',
                tenantDependent: true,
                value: '#FFE339',
            },
            'warning-pressed': {
                alias: 'status/warning-pressed',
                mode: 'tallinn',
                value: '#E9C500',
            },
        },
        'waiting-time': {
            'border-arrivals': {
                alias: 'waiting-time/border-arrivals',
                mode: 'tallinn',
                value: '#B59CF5',
                boundTo: 'violet/500',
                boundToCollection: '_Primitives graphics',
            },
            'border-departures': {
                alias: 'waiting-time/border-departures',
                mode: 'tallinn',
                value: '#F48D80',
                boundTo: 'red/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-departures': {
                alias: 'waiting-time/security-departures',
                mode: 'tallinn',
                value: '#6FB2FC',
                boundTo: 'blue/500',
                boundToCollection: '_Primitives graphics',
            },
            'security-transfer': {
                alias: 'waiting-time/security-transfer',
                mode: 'tallinn',
                value: '#08C6C8',
                boundTo: 'teal/500',
                boundToCollection: '_Primitives graphics',
            },
        },
    },
}
